import useSWR from "swr";

import { api } from "@is/services";
import { createStockSessionSegmentsUrl } from "@is/services/api/urlBuilders/createStockUrls";

export const useSessionSegments = (shouldFetchSessionSegments = false) => {
  const url = createStockSessionSegmentsUrl();

  const { data, error, isLoading } = useSWR(
    shouldFetchSessionSegments && url,
    api.get,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }
  );

  return { data, error, isLoading };
};
